import { render, staticRenderFns } from "./ImageCarousel.vue?vue&type=template&id=a4f1fb6e&"
import script from "./ImageCarousel.vue?vue&type=script&lang=js&"
export * from "./ImageCarousel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a4f1fb6e')) {
      api.createRecord('a4f1fb6e', component.options)
    } else {
      api.reload('a4f1fb6e', component.options)
    }
    module.hot.accept("./ImageCarousel.vue?vue&type=template&id=a4f1fb6e&", function () {
      api.rerender('a4f1fb6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-83M8h9S4UjSHY/JS/ImageCarousel.vue"
export default component.exports